import { Button } from "@/atoms";
import { invitationStatusValues, strings } from "@/constants";
import { ButtonSizeEnum, ButtonVariantEnum } from "@/enums";
import type { InvitationStatusType, InvitationType } from "@/types";
import { formatDateHandler } from "@/utils";

const statusBadgeStyle = (status: InvitationStatusType): string => {
    if (status === invitationStatusValues.accepted) return "text-primary bg-primary/10";

    if (status === invitationStatusValues.pending) return "text-yellow-700 bg-yellow-100";

    if (status === invitationStatusValues.cancelled) return "text-error bg-error/10";

    return "text-text-secondary bg-gray-100";
};

export const InvitationRow = ({
    invitation,
    isCancelling,
    onCancel,
}: {
    invitation: InvitationType,
    isCancelling: boolean,
    onCancel: (id: number) => void,
}) => {
    const {
        createdAt,
        email,
        id,
        status,
    } = invitation;

    return (
        <li
            className="
                flex
                flex-col
                gap-3
                px-4
                py-4
                transition-colors
                hover:bg-gray-50
                sm:flex-row
                sm:items-center
                sm:justify-between
                sm:px-6
            "
        >
            <div className="min-w-0 flex-1">
                <div
                    className="
                        flex
                        flex-wrap
                        items-center
                        gap-2
                    "
                >
                    <p
                        className="
                            truncate
                            text-sm
                            font-semibold
                            text-text-primary
                        "
                    >
                        {email}
                    </p>
                    <span
                        className={`
                            shrink-0
                            rounded-full
                            px-2
                            py-0.5
                            text-xs
                            font-semibold
                            tracking-wide
                            uppercase
                            ${statusBadgeStyle(status)}
                        `}
                    >
                        {status}
                    </span>
                </div>
                <p className="mt-1 text-xs text-text-secondary">
                    {strings.admin.invitedAt}
                    {": "}
                    {formatDateHandler(createdAt)}
                </p>
            </div>
            {status === invitationStatusValues.pending && (
                <Button
                    disabled={isCancelling}
                    size={ButtonSizeEnum.SM}
                    variant={ButtonVariantEnum.GHOST_DANGER}
                    onClick={() => onCancel(id)}
                >
                    {strings.admin.cancelInvitation}
                </Button>
            )}
        </li>
    );
};
